import axios from "axios";
import { endSession, isTokenExpired } from "./sessionUtils";

/**
 * Global axios interceptors so that direct axios calls (login, provider auth,
 * logout, onboarding, etc.) log the user out on an expired session, matching
 * the behaviour of the shared `Request` helper (fetchUtils.js).
 *
 * - Request interceptor: if the stored JWT is already expired, log out before
 *   sending (the authorizer 401 has no CORS headers and surfaces as a network
 *   error, so it can't be reliably caught in the response interceptor).
 * - Response interceptor: any 401 that does reach us -> log out.
 */
let installed = false;

export const setupAxiosInterceptors = () => {
  if (installed) return;
  installed = true;

  axios.interceptors.request.use((config) => {
    if (isTokenExpired()) {
      endSession();
    }
    return config;
  });

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        endSession();
      }
      return Promise.reject(error);
    }
  );
};
